export const albumTitleFontOptions = [
  { value: "playfair", label: "Playfair Display" },
  { value: "cormorant", label: "Cormorant Garamond" },
  { value: "dmserif", label: "DM Serif Display" },
  { value: "montserrat", label: "Montserrat" },
  { value: "poppins", label: "Poppins" },
  { value: "bebas", label: "Bebas Neue" },
  { value: "inter", label: "Inter" }
];

export const getAlbumTitleFontClass = (font) => {
  switch (font) {
    case "cormorant":
      return "font-['Cormorant_Garamond']";
    case "dmserif":
      return "font-['DM_Serif_Display']";
    case "montserrat":
      return "font-['Montserrat']";
    case "poppins":
      return "font-['Poppins']";
    case "bebas":
      return "font-['Bebas_Neue']";
    case "inter":
      return "font-['Inter']";
    case "playfair":
    default:
      return "font-['Playfair_Display']";
  }
};
